import { createAction, props } from '@ngrx/store';
import { Frequency, FrequencyOffsetOption } from '../services/frequencyoptions.service';

export interface IFandCGeneratorState {
  rootTemplate: any | null;
  loans: any[];
  selectedLoanNumber: string | null;
  selectedLoanDetail: any | null;
  templateTypes: any[];
  templates: any[];
  defaultTasksForTemplate: any[];
  selectedDefaultTasks: any[];
  prototypeTasks: any[];
  selectedPrototypeTasks: any[];
  generatedTasks: any[];
  selectedReferenceDate: Date | null;
  selectedMaturityDate: Date | null;
  firstDueDate: Date | null;
  frequencyOptions: Frequency[];
  selectedFrequency: Frequency | null;
  frequencyOffsetOptions: FrequencyOffsetOption[];
  selectedFrequencyOffsetValue: string | null;
  formatOptions: string[];
  selectedFormatOption: string | null;
  selectedTemplateType: string | null;
  reportEntityOptions: { label: string; value: string }[];
  selectedReportEntity: string | null;
  entityNameOptions: { label: string; value: string }[];
  selectedEntityName: string | null;
  category: string | null;
  tasks: any[];
  taskId: string | null;
  taskGenerationMetadataId: string | null;
  existingTaskIds: string[];
  lastGeneratedSelectedDefaultTasks: string[];
  reviewerList: { id: string; name: string }[];
  selectedReviewerId: string | null;
  selectedReviewerName: string | null;
  lastPrototypeGenerateResult: {
    addedCount: number;
    duplicateRowIds: string[];
    token: number;
  } | null;
}

export const initialFandCGeneratorState: IFandCGeneratorState = {
  rootTemplate: null,
  loans: [],
  selectedLoanNumber: null,
  selectedLoanDetail: null,
  templateTypes: [],
  templates: [],
  defaultTasksForTemplate: [],
  selectedDefaultTasks: [],
  prototypeTasks: [],
  selectedPrototypeTasks: [],
  generatedTasks: [],
  selectedReferenceDate: null,
  selectedMaturityDate: null,
  firstDueDate: null,
  frequencyOptions: [],
  selectedFrequency: null,
  frequencyOffsetOptions: [],
  selectedFrequencyOffsetValue: null,
  formatOptions: [],
  selectedFormatOption: null,
  selectedTemplateType: null,
  reportEntityOptions: [],
  selectedReportEntity: null,
  entityNameOptions: [],
  selectedEntityName: null,
  category: null,
  tasks: [],
  taskId: null,
  taskGenerationMetadataId: null,
  existingTaskIds: [],
  lastGeneratedSelectedDefaultTasks: [],
  reviewerList: [],
  selectedReviewerId: null,
  selectedReviewerName: null,
  lastPrototypeGenerateResult: null,
};

